export default __webpack_public_path__ + "media/images/mailer/icon_grade-15655c70b6fe2ca2f8547db15929187a.png";